export const actionIDs = {
    bookService: "bookService",
    bookServiceMaps: "bookServiceMaps",
    bookCM: "bookCM",
    bookCMMaps: "bookCMMaps",
    bookInst: "bookInst",
    bookInstMaps: "bookInstMaps",
    moveToSupply: "moveToSupply",
    resendToSupply: "resendToSupply",
    alterTags: "alterTags",
    updateCommitReason: "updateCommitReason",
    updateCommissionDate: "updateCommissionDate",
    updateETA: "updateETA",
    goodsReceived: "goodsReceived",
    closeJob: "closeJob",
    cancelJob: "cancelJob",
    invoiceJob: "invoiceJob",
    invoiceJobGenerate: "invoiceJobGenerate",
    editJob: "editJob",
    finishEditJob: "finishEditJob",
    newPayment: "newPayment",
    planInstaller: "planInstaller",
    sendOrderConfirmation: "sendOrderConfirmation",
    printOrderConfirmation: "printOrderConfirmation",
    printInstallJobSheet: "printInstallJobSheet",
    showInstallSummary: "showInstallSummary",
    markAsDispatched: "markAsDispatched",
    processInstall: "processInstall"

};


export const trackingViews = {
    quoting_active: 'quoting_active',
    quoting_open: 'quoting_open',
    quoting_sent: 'quoting_sent',
    quoting_expired: 'quoting_expired',
    quoting_lost: 'quoting_lost',
    jobs_active: 'jobs_active',
    jobs_all_orders: 'jobs_all_orders',
    opps_lead: 'opps_lead',
    opps_quotation: 'opps_quotation',
    opps_negotiation: 'opps_negotiation',
    opps_won: 'opps_won',
    opps_lost: 'opps_lost',
    projects_all: 'projects_all',
    mf_scheduler: 'mf_scheduler',
    dispatch_job_planning: 'dispatch_job_planning',
    dispatch_scheduler: 'dispatch_scheduler',
    restock_restock: 'restock_restock',
    restock_all: 'restock_all',
    service_pending_approval: 'service_pending_approval',
    service_sent: 'service_sent',
    service_approved: 'service_approved',
    service_expired: 'service_expired',
    costco_new: 'costco_new',
    costco_estimate: 'costco_estimate',
    costco_quoted: 'costco_quoted',
    costco_sold: 'costco_sold',
    costco_completed: 'costco_completed',
    costco_cancelled: 'costco_cancelled',

}

export const costcoOpportunityViews = [
    trackingViews.costco_new,
    trackingViews.costco_estimate,
    trackingViews.costco_quoted,
    trackingViews.costco_cancelled,
];

export const costcoJobViews = [
    trackingViews.costco_sold,
    trackingViews.costco_completed,
];

export const costcoMilestoneFromView = view => view?.replace("costco_", "");